var _defs, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3597.9734,
    y1: 4060.344,
    x2: 1124.4301,
    y2: 988.3583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_1_)"
    },
    d: "M2923.63,2844.602c-57.153,59.582-111.231,98.005-153.957,128.362 c-502.233,356.842-1096.508,252.825-1222.809,227.422c-186.506-37.511-547.018-110.018-807.661-413.54 c-394.332-459.202-332.929-1182.662-27.058-1660.229c55.948-87.355,351.485-572.195,952.161-649.949 c363.523-47.055,787.273,47.85,1094.142,302.436C3402.593,1313.506,3356.737,2393.09,2923.63,2844.602z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047044283387672693350000013830478197726271131_",
    gradientUnits: "userSpaceOnUse",
    x1: 2890.8262,
    y1: 2033.286,
    x2: 3758.8384,
    y2: 315.5991,
    gradientTransform: "matrix(-0.5701 -0.8216 -0.8216 0.5701 3942.5818 2902.6289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047044283387672693350000013830478197726271131_)"
    },
    d: "M706.388,1992.752 c113.202-190.358,549.545-951.437,624.007-1493.325c5.317-38.694-37.908-58.036-75.544-33.578 C1016.984,620.43,375.59,1131.1,665.136,1995.946C670.525,2012.046,696.109,2010.038,706.388,1992.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "#FFFFFF"
    },
    d: "M679.001,1980.543c1.81,2.134,4.375,3.646,7.36,4.096 c6.55,0.979,12.655-3.534,13.632-10.081c118.646-792.213,458.748-1236.589,462.171-1240.987 c4.064-5.226,3.093-12.74-2.093-16.825c-5.224-4.066-12.753-3.133-16.826,2.093c-0.867,1.112-87.954,113.84-188.425,323.6 c-92.572,193.274-216.038,511.257-278.537,928.569C675.75,1974.566,676.841,1977.997,679.001,1980.543z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032617879076690385970000011301722423846016905_",
    gradientUnits: "userSpaceOnUse",
    x1: 3203.0076,
    y1: 2537.6062,
    x2: 4370.0664,
    y2: 1385.1335,
    gradientTransform: "matrix(-0.4849 -0.8746 -0.8746 0.4849 4325.5996 3234.3435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032617879076690385970000011301722423846016905_)"
    },
    d: "M666.763,1881.4 c11.629,17.785,37.643,17.914,49.677,0.4c66.401-96.638,229.435-386.844,115.109-775.135 c-96.543-327.894-117.733-514.866-121.471-600.411c-0.791-18.09-24.214-24.655-34.322-9.632 C564.248,662.37,245.362,1236.938,666.763,1881.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111192100093701592540000016890685227445239438_",
    gradientUnits: "userSpaceOnUse",
    x1: 2609.6133,
    y1: 1546.668,
    x2: 3382.73,
    y2: 1546.668,
    gradientTransform: "matrix(-0.6653 -0.7466 -0.7466 0.6653 3830.1069 2586.8047)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000111192100093701592540000016890685227445239438_)"
    },
    d: "M688.168,1873.736 c1.725,2.504,4.428,4.326,7.665,4.856c6.301,1.026,12.244-3.254,13.271-9.555c0.835-5.135,82.252-518.63-31.55-981.247 c-1.513-6.215-7.794-9.988-13.991-8.464c-6.198,1.521-9.991,7.789-8.463,13.986c112.686,458.089,32.007,966.922,31.178,972.008 C685.778,1868.386,686.536,1871.368,688.168,1873.736z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168804986060283807620000008774103845367746726_",
    gradientUnits: "userSpaceOnUse",
    x1: 1936.9264,
    y1: 3235.6902,
    x2: 1901.4987,
    y2: 2534.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000168804986060283807620000008774103845367746726_)"
    },
    points: "1640.868,2439.345  1582.027,2967.063 2264.691,2967.063 2175.773,2439.345  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010302064553035097940000017338367493985092491_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.9753,
    y1: 1765.5818,
    x2: 3257.0247,
    y2: 1765.5818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010302064553035097940000017338367493985092491_)"
    },
    d: "M452.975,1101.447v1243.67 c0,102.309,81.527,185.972,183.801,188.61c454.249,11.713,2042.993,40.115,2475.408,33.741 c74.321-1.095,134.527-60.57,136.672-134.868c8.338-288.922,21.88-983.681-28.234-1306.231 c-10.554-67.926-67.889-118.719-136.594-120.916c-380.604-12.176-2064.776-50.837-2496.989-41.131 C512.497,965.996,452.975,1026.886,452.975,1101.447z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150060240999362292420000015350687858194541733_",
    gradientUnits: "userSpaceOnUse",
    x1: 1968.0767,
    y1: 32.1111,
    x2: 1694.0317,
    y2: 3736.8037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150060240999362292420000015350687858194541733_)"
    },
    d: "M531.012,1095.392v1181.573 c0,59.733,47.949,108.406,107.676,109.299l2411.287,29.791c59.214,0.885,107.753-46.755,107.973-105.976l4.034-1171.016 c0.158-42.344-33.577-77.039-75.909-78.07l-2468.711-49.874C570.016,1009.966,531.012,1048.033,531.012,1095.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M3176.104,2465.012c-0.023,0-0.044,0-0.068,0l-2645.089-45.067 c-2.139-0.039-3.846-1.803-3.809-3.942c0.035-2.139,1.78-3.826,3.94-3.811l2645.088,45.067c2.14,0.039,3.846,1.803,3.809,3.942 C3179.941,2463.317,3178.212,2465.012,3176.104,2465.012z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085248791702646269830000006869683501679967887_",
    gradientUnits: "userSpaceOnUse",
    x1: 1939.1312,
    y1: 2971.0005,
    x2: 1613.1986,
    y2: 3686.6345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085248791702646269830000006869683501679967887_)"
    },
    d: "M2411.736,3075.033h-999.125 c-27.143,0-47.527-19.323-42.278-40.079l12.821-50.703c3.855-15.248,20.63-26.443,40.554-27.064l963.192-30.056 c20.816-0.649,39.247,10.4,43.782,26.247l23.112,80.758C2459.799,3055.117,2439.318,3075.033,2411.736,3075.033z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096050117344509642720000015961211721253774751_",
    d: "M517.051,1092.979V2274.82 c0,59.747,48.146,108.43,108.117,109.323l2421.152,29.798c59.457,0.885,108.193-46.766,108.415-106l4.05-1171.281 c0.159-42.354-33.714-77.057-76.22-78.087l-2478.811-49.885C556.214,1007.534,517.051,1045.609,517.051,1092.979z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053524975112399926610000002018882617745710229_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096050117344509642720000015961211721253774751_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000053524975112399926610000002018882617745710229_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fill: "#FFFFFF"
    },
    d: "M1474.981,1677.001c-146.52-40.569-316.609-99.258-398.664-36.173 c-82.055,63.084-129.019,135.16-246.252,112.646c-117.233-22.516-116.706-130.767-211.073-90.198 c-48.019,20.691-75.634,4.193-91.201-16.972l-14.435-462.708c5.804-105.816-49.322-197.48,233.598-185.175l589.861,31.849 c12.841,13.116,9.938,15.065,16.534,34.283h10.29c0,0,175.894,45.638,152.413,176.338 c-23.482,130.766-112.925,116.565,2.11,215.689C1633.286,1555.77,1621.589,1717.57,1474.981,1677.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fill: "#FFFFFF"
    },
    d: "M1889.954,2100.473c-29.286,117.242-175.894,76.674-310.717,162.275 c-134.91,85.667,0,175.797-211.073,175.797s-380.547-16.702-422.146,63.151c-41.687,79.854-357.68-18.052-316.609-130.766 c25.593-70.388-35.114-193.551-98.875-266.169v-248.634c8.355,2.841,42.941-2.653,51.912,0.931 c0,0,129.018,58.622,287.322,18.053c129.018-33.065,199.815-75.661,284.948-131.307 c44.414-29.075,105.712-37.798,160.591-22.787c140.452,38.406,201.927,121.165,320.215,136.042 C1778.525,1875.113,1919.24,1983.296,1889.954,2100.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fill: "#FFFFFF"
    },
    d: "M2248.177,1332.623c0,0-309.914,119.134-247.931,226.353 c61.983,107.22-39.188,163.539,119.868,177.076c159.055,13.537,412.152,72.596,494.796-30.399 C2697.553,1602.658,2521.935,1253.202,2248.177,1332.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fill: "#FFFFFF"
    },
    d: "M2678.463,2424.085c0.009,0.202,0.017,0.404,0.025,0.605 c1.06,26.708-33.236,46.053-66.234,37.667c-151.292-38.452-194.556,63.526-394.281,70.398 c-222.769,7.668-152.413-84.573-316.609-169.088c-164.109-84.572-87.947-153.752,105.536-215.264 c137.813-43.757,281.518-48.6,352.842-47.734c29.726,0.345,59.805-2.249,88.299-7.61c0.901-0.168,1.799-0.334,2.696-0.499 c109.341-19.999,214.957,42.482,218.772,128.841L2678.463,2424.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fill: "#FFFFFF"
    },
    d: "M2539.528,1939.426c1.31,4.14,3.151,8.141,5.572,11.927 c15.02,23.489,45.353,30.824,71.712,40.357c44.67,16.154,88.838,50.329,92.385,97.323c1.513,20.043-4.638,39.96-4.303,60.057 c1.14,68.43,71.744,112.179,133.51,142.788c79.374,39.335,158.748,78.67,238.122,118.006 c51.889,25.715,105.68,49.841,109.092-20.04c1.759-36.027,1.099-72.343,1.646-108.409 c1.279-84.246,2.559-168.492,3.838-252.738c4.427-291.495,8.854-582.991,13.281-874.486 c-2.54-85.446-78.127-116.155-123.947-114.342c-77.205-2.053-154.411-4.106-231.616-6.158 c-64.612-1.718-439.365-54.646-406.022,64.658c4.129,14.773,13.839,27.291,23.334,39.393 c59.244,75.515,118.607,151.168,184.993,220.603c28.447,29.754,58.463,58.727,79.591,93.965 c17.923,29.894,28.847,63.327,38.807,96.67c12.592,42.155,23.977,85.533,21.852,129.447 c-2.125,43.914-19.667,89.047-55.294,115.242c-25.427,18.695-57.243,26.115-87.894,33.977 c-30.65,7.861-62.327,17.27-85.441,38.712C2542.932,1884.753,2531.669,1914.587,2539.528,1939.426z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000053524975112399926610000002018882617745710229_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000171713222814973207670000006347634832634380437_",
    d: "M3137.162,2343.646 c0.879,23.599,3.97,150.199-2.627,171.43c-23.833,77.014-84.19,42.847-166.597,44.741H702.387 c-146.405,17.751-164.211-46.061-157.968-160.059l-13.771-279.475l-0.114-264.155l-4.98-194.971l-14.488-467.886 c5.804-105.816,70.17-186.073,172.187-182.827l669.258,13.061l1584.716,50.237c98.765,3.11,206.892,7.42,216.778,170.781 l-8.256,710.778L3137.162,2343.646z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038381043854254481010000011681776162876114064_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171713222814973207670000006347634832634380437_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038381043854254481010000011681776162876114064_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 636.291,
    y: 1004.155,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.383,
    height: 1584.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1082.659,
    y: 1004.155,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.383,
    height: 1584.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1521.884,
    y: 1004.155,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.383,
    height: 1584.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1953.968,
    y: 1004.155,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.383,
    height: 1584.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2400.336,
    y: 1004.155,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.383,
    height: 1584.086
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2839.561,
    y: 1004.155,
    style: {
      fill: "#FFFFFF"
    },
    width: 3.383,
    height: 1584.086
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -138.697,
    y: 951.673,
    style: {
      fill: "#FFFFFF"
    },
    width: 3438.817,
    height: 3.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: -138.697,
    y: 1292.099,
    style: {
      fill: "#FFFFFF"
    },
    width: 3438.817,
    height: 3.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: -138.697,
    y: 1627.038,
    style: {
      fill: "#FFFFFF"
    },
    width: 3438.817,
    height: 3.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: -117.273,
    y: 1964.718,
    style: {
      fill: "#FFFFFF"
    },
    width: 3435.247,
    height: 3.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: -117.273,
    y: 2305.147,
    style: {
      fill: "#FFFFFF"
    },
    width: 3435.247,
    height: 3.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: -117.273,
    y: 2640.083,
    style: {
      fill: "#FFFFFF"
    },
    width: 3435.247,
    height: 3.383
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022530831477473113450000001926741369020653710_",
    gradientUnits: "userSpaceOnUse",
    x1: -128.9728,
    y1: 902.4528,
    x2: 383.1365,
    y2: 902.4528,
    gradientTransform: "matrix(0.9914 0.1306 -0.1306 0.9914 1084.3943 1734.7203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022530831477473113450000001926741369020653710_)"
    },
    d: "M1313.151,2860.652 c-4.703-0.816-7.853-5.292-7.035-9.993c1.586-9.135,2.8-18.475,3.606-27.761c0.408-4.698,4.504-8.19,9.189-7.873 c0.056,0.004,0.111,0.008,0.168,0.011c4.754,0.413,8.273,4.603,7.86,9.358c-0.849,9.774-2.126,19.606-3.797,29.223 c-0.763,4.397-4.729,7.437-9.086,7.142C1313.755,2860.74,1313.453,2860.706,1313.151,2860.652z M1310.546,2777.432 c-0.466-9.304-1.336-18.677-2.584-27.865c-0.643-4.725,2.668-9.082,7.397-9.726c4.749-0.629,9.084,2.671,9.726,7.401 c1.315,9.666,2.23,19.532,2.723,29.322c0.239,4.766-3.432,8.824-8.198,9.063c-0.346,0.017-0.689,0.014-1.026-0.009 C1314.274,2785.326,1310.768,2781.852,1310.546,2777.432z M1298.72,2705.067c-2.519-8.943-5.458-17.884-8.737-26.58 c-1.683-4.464,0.572-9.451,5.036-11.135c4.463-1.677,9.447,0.572,11.134,5.037c3.453,9.158,6.549,18.576,9.2,27.992 c1.294,4.594-1.382,9.365-5.974,10.661c-0.979,0.275-1.967,0.371-2.927,0.306 C1302.911,2711.108,1299.738,2708.681,1298.72,2705.067z M1271.006,2637.164c-4.459-8.164-9.326-16.227-14.462-23.97 c-2.637-3.978-1.552-9.341,2.424-11.978c3.979-2.633,9.339-1.547,11.978,2.424c5.407,8.154,10.53,16.644,15.226,25.233 c2.287,4.187,0.748,9.438-3.439,11.726c-1.498,0.819-3.132,1.148-4.719,1.041 C1275.167,2641.448,1272.477,2639.851,1271.006,2637.164z M1228.856,2577.127c-6.146-6.952-12.678-13.741-19.415-20.171 c-3.451-3.298-3.576-8.767-0.281-12.218c3.297-3.454,8.768-3.578,12.216-0.279c7.087,6.766,13.959,13.909,20.427,21.224 c3.161,3.573,2.826,9.035-0.751,12.196c-1.801,1.593-4.082,2.298-6.306,2.148 C1232.557,2579.878,1230.424,2578.901,1228.856,2577.127z M1174.473,2527.914c-7.542-5.429-15.411-10.6-23.39-15.372 c-4.095-2.449-5.431-7.756-2.982-11.85c2.449-4.097,7.753-5.433,11.852-2.984c8.397,5.021,16.68,10.466,24.618,16.179 c3.872,2.789,4.752,8.187,1.964,12.062c-1.811,2.516-4.724,3.767-7.605,3.572 C1177.375,2529.416,1175.831,2528.892,1174.473,2527.914z M856.895,2482.022c-1.677-4.468,0.586-9.45,5.055-11.126 c9.154-3.433,18.582-6.513,28.021-9.152c4.597-1.286,9.365,1.398,10.648,5.995c1.286,4.593-1.398,9.361-5.993,10.646 c-8.962,2.506-17.914,5.432-26.606,8.693c-1.192,0.447-2.42,0.614-3.614,0.533 C861.129,2487.39,858.123,2485.299,856.895,2482.022z M1110.572,2492.001c-8.556-3.614-17.373-6.9-26.209-9.765 c-4.54-1.474-7.026-6.349-5.554-10.887c1.473-4.542,6.342-7.003,10.887-5.552c9.304,3.018,18.589,6.479,27.6,10.285 c4.396,1.857,6.454,6.926,4.597,11.323c-1.472,3.487-4.967,5.503-8.543,5.261 C1112.419,2492.603,1111.481,2492.384,1110.572,2492.001z M929.442,2461.811c-0.634-4.729,2.688-9.078,7.419-9.711 c9.689-1.296,19.562-2.191,29.344-2.665c4.77-0.252,8.816,3.448,9.049,8.214c0.23,4.765-3.447,8.816-8.214,9.049 c-9.297,0.45-18.68,1.3-27.887,2.534c-0.587,0.079-1.169,0.093-1.738,0.055C933.4,2469.014,929.996,2465.952,929.442,2461.811z  M1040.261,2471.274c-9.144-1.607-18.477-2.841-27.743-3.664c-4.755-0.42-8.265-4.616-7.843-9.371 c0.417-4.691,4.51-8.173,9.187-7.856c0.061,0.004,0.123,0.009,0.183,0.016c9.756,0.863,19.582,2.161,29.206,3.851 c4.7,0.829,7.841,5.308,7.016,10.009c-0.771,4.39-4.733,7.42-9.084,7.125 C1040.878,2471.363,1040.569,2471.325,1040.261,2471.274z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062185594370210144080000000465975766781110660_",
    gradientUnits: "userSpaceOnUse",
    x1: 1487.2841,
    y1: 742.9765,
    x2: 1516.0701,
    y2: 742.9765,
    gradientTransform: "matrix(-0.9977 -0.0675 -0.0675 0.9977 2364.7034 1862.0195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062185594370210144080000000465975766781110660_)"
    },
    d: "M809.758,2513.978 c1.697,0.115,3.447-0.267,5.018-1.209c3.821-2.292,7.753-4.54,11.688-6.689c4.189-2.284,5.733-7.535,3.447-11.722 c-2.284-4.19-7.536-5.74-11.724-3.446c-4.14,2.257-8.275,4.623-12.296,7.033c-4.092,2.453-5.422,7.762-2.969,11.853 C804.433,2512.322,807.03,2513.794,809.758,2513.978z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147902450287745341970000005909433362555404932_",
    gradientUnits: "userSpaceOnUse",
    x1: 1636.7052,
    y1: 962.9315,
    x2: 1656.4589,
    y2: 962.9315,
    gradientTransform: "matrix(-0.9977 -0.0675 -0.0675 0.9977 2364.7034 1862.0195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147902450287745341970000005909433362555404932_)"
    },
    d: "M654.647,2726.916 c4.161,0.282,8.027-2.488,8.995-6.682c0.999-4.341,2.107-8.734,3.292-13.056c1.262-4.603-1.445-9.357-6.047-10.619 c-4.622-1.267-9.358,1.447-10.62,6.048c-1.247,4.55-2.414,9.177-3.468,13.747c-1.071,4.65,1.831,9.288,6.481,10.361 C653.737,2726.821,654.194,2726.885,654.647,2726.916z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034811202866897090210000014381510273748549768_",
    gradientUnits: "userSpaceOnUse",
    x1: -306.9266,
    y1: 1238.6313,
    x2: 219.1503,
    y2: 1238.6313,
    gradientTransform: "matrix(0.9914 0.1306 -0.1306 0.9914 1084.3943 1734.7203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034811202866897090210000014381510273748549768_)"
    },
    d: "M942.53,3136.914 c-4.74-0.554-8.133-4.847-7.577-9.59c0.556-4.739,4.843-8.123,9.588-7.575c9.024,1.057,18.233,1.745,27.476,2.059 c4.747,0.145,8.504,4.162,8.342,8.931s-4.16,8.504-8.93,8.344c-4.005-0.136-7.992-0.338-11.958-0.606 C953.812,3138.094,948.112,3137.569,942.53,3136.914z M1009.021,3129.766c-0.484-4.745,2.971-8.987,7.718-9.471 c9.115-0.933,18.288-2.257,27.265-3.943c4.682-0.894,9.207,2.206,10.089,6.897c0.88,4.688-2.208,9.205-6.898,10.085 c-9.452,1.776-19.109,3.172-28.7,4.15c-0.497,0.051-0.99,0.058-1.472,0.026 C1012.9,3137.232,1009.455,3134.018,1009.021,3129.766z M896.248,3128.247c-9.306-2.413-18.637-5.257-27.732-8.457 c-4.502-1.583-6.868-6.517-5.284-11.021c1.584-4.5,6.515-6.86,11.02-5.283c8.637,3.041,17.496,5.741,26.333,8.031 c4.62,1.199,7.394,5.913,6.197,10.535c-1.06,4.086-4.874,6.727-8.938,6.452C897.314,3128.468,896.78,3128.384,896.248,3128.247 z M1081.847,3116.035c-1.516-4.524,0.924-9.424,5.449-10.937c8.675-2.904,17.328-6.216,25.719-9.839 c4.384-1.896,9.466,0.123,11.358,4.507c1.892,4.38-0.125,9.464-4.505,11.356c-8.838,3.817-17.951,7.303-27.084,10.363 c-1.104,0.368-2.229,0.505-3.324,0.431C1086.07,3121.687,1082.992,3119.455,1081.847,3116.035z M825.309,3101.161 c-8.542-4.398-17.015-9.224-25.185-14.344c-4.044-2.533-5.268-7.863-2.736-11.907c2.534-4.047,7.867-5.27,11.911-2.736 c7.762,4.862,15.809,9.447,23.921,13.622c4.243,2.185,5.912,7.396,3.727,11.64c-1.628,3.161-4.935,4.893-8.27,4.667 C827.536,3102.025,826.389,3101.718,825.309,3101.161z M762.029,3059.173c-7.392-6.174-14.609-12.731-21.452-19.49 c-3.394-3.356-3.428-8.825-0.075-12.221c3.359-3.399,8.829-3.432,12.22-0.073c6.502,6.421,13.361,12.654,20.384,18.522 c3.663,3.059,4.152,8.509,1.092,12.172c-1.844,2.206-4.556,3.26-7.221,3.08 C765.219,3061.043,763.483,3060.388,762.029,3059.173z M709.401,3004.392c-5.875-7.641-11.493-15.616-16.696-23.698 c-2.584-4.015-1.424-9.359,2.588-11.943c4.018-2.587,9.361-1.423,11.943,2.588c4.944,7.683,10.282,15.256,15.866,22.519 c2.909,3.783,2.2,9.209-1.583,12.116c-1.738,1.337-3.82,1.91-5.847,1.772C713.283,3007.584,710.974,3006.437,709.401,3004.392z  M669.977,2939.435c-4.062-8.74-7.797-17.754-11.101-26.794c-1.639-4.482,0.666-9.445,5.15-11.083 c4.475-1.636,9.442,0.67,11.081,5.151c3.137,8.582,6.683,17.141,10.543,25.444c2.011,4.327,0.134,9.465-4.194,11.475 c-1.367,0.635-2.813,0.882-4.218,0.787C674.196,2944.21,671.355,2942.397,669.977,2939.435z M645.778,2867.365 c-2.031-9.397-3.687-19.005-4.921-28.561c-0.611-4.734,2.73-9.068,7.463-9.678c4.718-0.608,9.065,2.728,9.676,7.462 c1.172,9.078,2.745,18.204,4.673,27.13c1.009,4.663-1.956,9.262-6.62,10.269c-0.812,0.175-1.623,0.232-2.412,0.178 C649.892,2873.912,646.61,2871.217,645.778,2867.365z M638.002,2791.82c0.047-7.084,0.312-14.255,0.79-21.311 c0.173-2.556,0.374-5.1,0.602-7.639c0.426-4.751,4.573-8.357,9.377-7.833c4.753,0.423,8.261,4.622,7.836,9.377 c-0.216,2.411-0.408,4.834-0.573,7.262c-0.454,6.709-0.707,13.521-0.752,20.258c-0.031,4.771-3.926,8.615-8.697,8.583 c-0.179-0.002-0.358-0.007-0.535-0.019C641.529,2800.191,637.97,2796.412,638.002,2791.82z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122712009299485109540000016135372650413401497_",
    gradientUnits: "userSpaceOnUse",
    x1: 1102.4084,
    y1: 1294.6466,
    x2: 1130.8273,
    y2: 1294.6466,
    gradientTransform: "matrix(-0.9977 -0.0675 -0.0675 0.9977 2364.7034 1862.0195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122712009299485109540000016135372650413401497_)"
    },
    d: "M1156.857,3090.641 c1.714,0.116,3.478-0.275,5.057-1.231c4-2.426,8.025-4.981,11.962-7.597c3.976-2.64,5.058-8.003,2.418-11.978 c-2.642-3.975-8-5.061-11.978-2.418c-3.74,2.484-7.564,4.911-11.361,7.215c-4.08,2.471-5.383,7.785-2.909,11.867 C1151.562,3089,1154.146,3090.458,1156.857,3090.641z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049904285886679780880000015108568748398160805_",
    gradientUnits: "userSpaceOnUse",
    x1: -950.2515,
    y1: 3087.2261,
    x2: -616.7332,
    y2: 2543.0652,
    gradientTransform: "matrix(0.6694 0.7429 -0.7429 0.6694 3584.21 1491.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049904285886679780880000015108568748398160805_)"
    },
    d: "M1192.269,2946.799 c1.177-1.259,1.426-3.125,0.62-4.648l-22.99-43.446c11.445-19.898,19.799-41.765,24.416-64.932l45.879-17.553 c1.609-0.616,2.65-2.185,2.593-3.907l-1.967-58.926c-0.057-1.722-1.201-3.219-2.847-3.725l-46.948-14.455 c-6.152-22.808-15.945-44.069-28.692-63.16l20.042-44.882c0.702-1.573,0.329-3.419-0.929-4.596l-43.058-40.277 c-1.258-1.177-3.125-1.427-4.648-0.62l-43.445,22.99c-19.898-11.445-41.765-19.8-64.932-24.417l-17.554-45.879 c-0.616-1.61-2.184-2.651-3.906-2.593l-58.927,1.966c-1.722,0.058-3.217,1.202-3.725,2.848l-14.455,46.948 c-22.808,6.152-44.069,15.945-63.159,28.692l-44.882-20.042c-1.573-0.702-3.419-0.33-4.596,0.929l-40.277,43.058 c-1.177,1.258-1.425,3.125-0.62,4.647l22.991,43.447c-11.446,19.898-19.799,41.764-24.416,64.932l-45.879,17.554 c-1.61,0.615-2.651,2.184-2.593,3.906l1.967,58.927c0.058,1.722,1.201,3.218,2.848,3.725l46.948,14.456 c6.152,22.808,15.946,44.069,28.692,63.16l-20.041,44.882c-0.703,1.573-0.33,3.418,0.929,4.596l43.058,40.276 c1.258,1.177,3.125,1.426,4.647,0.62l43.446-22.99c19.898,11.446,41.764,19.799,64.932,24.417l17.554,45.879 c0.616,1.608,2.184,2.65,3.907,2.593l58.927-1.968c1.722-0.058,3.218-1.201,3.725-2.848l14.455-46.946 c22.808-6.152,44.068-15.947,63.159-28.693l44.882,20.042c1.573,0.703,3.419,0.329,4.596-0.929L1192.269,2946.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "#FFFFFF"
    },
    d: "M970.494,2849.4c-31.933-6.938-52.27-38.559-45.333-70.496 c3.359-15.47,12.544-28.706,25.859-37.266c13.312-8.562,29.164-11.43,44.635-8.065c31.933,6.938,52.27,38.559,45.333,70.496 c-6.312,29.053-33.054,48.505-61.877,46.554C976.254,2850.43,973.373,2850.025,970.494,2849.4z M958.498,2753.268 c-10.209,6.565-17.25,16.712-19.827,28.574c-5.317,24.482,10.274,48.731,34.758,54.049 c24.489,5.328,48.731-10.274,54.051-34.759c5.318-24.482-10.274-48.731-34.758-54.049c-2.22-0.482-4.447-0.795-6.673-0.946 C976.381,2745.483,966.795,2747.933,958.498,2753.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "#FFFFFF"
    },
    d: "M972.122,2935.944c4.95,0.335,9.946,0.423,14.973,0.256l0,0 c1.582-0.052,3.164-0.131,4.744-0.234c7.79-0.511,15.528-1.642,23.093-3.373c0.103-0.023,0.206-0.047,0.309-0.07 c0.292-0.068,0.584-0.136,0.877-0.208c0.569-0.134,1.136-0.275,1.703-0.416c1.49-0.373,2.509-1.66,2.609-3.115 c0.024-0.354-0.007-0.718-0.098-1.079c-0.464-1.851-2.343-2.97-4.193-2.51c-9.528,2.39-19.376,3.767-29.273,4.094 c-49.161,1.649-93.283-22.61-119.222-60.456c-14.43-21.049-23.232-46.303-24.143-73.646c-0.161-4.794-0.078-9.562,0.243-14.284 c2.154-31.776,15.064-61.597,37.115-85.169c25.328-27.079,59.686-42.673,96.742-43.91 c76.531-2.547,140.812,57.607,143.365,134.102c0.158,4.716,0.076,9.424-0.242,14.101c-1.375,20.27-7.171,40.013-17.04,57.793 c-0.255,0.46-0.394,0.951-0.426,1.443c-0.088,1.293,0.561,2.585,1.771,3.256c1.673,0.922,3.773,0.33,4.7-1.346 c10.36-18.667,16.447-39.395,17.891-60.675c0.334-4.91,0.42-9.85,0.256-14.8c-2.68-80.313-70.221-143.462-150.504-140.783 c-38.903,1.298-74.97,17.67-101.56,46.097c-23.151,24.746-36.703,56.052-38.966,89.412c-0.336,4.957-0.422,9.961-0.256,14.993 c1.299,38.905,17.67,74.974,46.096,101.563C907.439,2920.135,938.755,2933.686,972.122,2935.944z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134944396831861042920000017232084703239056813_",
    gradientUnits: "userSpaceOnUse",
    x1: 677.2741,
    y1: 1283.3385,
    x2: 691.3235,
    y2: 1283.3385,
    gradientTransform: "matrix(-0.9977 -0.0675 -0.0675 0.9977 2364.7034 1862.0195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134944396831861042920000017232084703239056813_)"
    },
    d: "M1592.877,3107.867 c2.304,0.156,4.527-1.203,5.365-3.481c1.567-4.251,3.027-8.608,4.337-12.949c0.851-2.821-0.744-5.796-3.567-6.651 c-2.823-0.865-5.799,0.746-6.651,3.567c-1.249,4.137-2.64,8.289-4.135,12.346c-1.02,2.762,0.397,5.83,3.162,6.853 C1591.881,3107.732,1592.381,3107.833,1592.877,3107.867z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057856692855555196400000006198014081474157206_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.6508,
    y1: 1131.9399,
    x2: 693.9788,
    y2: 1131.9399,
    gradientTransform: "matrix(0.9914 0.1306 -0.1306 0.9914 1084.3943 1734.7203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057856692855555196400000006198014081474157206_)"
    },
    d: "M1602.934,3068.142 c-2.905-0.499-4.857-3.254-4.36-6.161c1.251-7.333,2.142-14.815,2.644-22.236c0.106-1.565,0.194-3.137,0.267-4.715 c0.139-2.942,2.636-5.218,5.581-5.081c2.779,0.24,5.218,2.636,5.083,5.583c-0.078,1.651-0.171,3.295-0.281,4.933 c-0.526,7.779-1.46,15.625-2.775,23.314c-0.464,2.721-2.916,4.608-5.615,4.426 C1603.299,3068.193,1603.118,3068.17,1602.934,3068.142z M1601.097,3007.929c-0.679-8.994-1.919-18.026-3.692-26.844 c-0.58-2.892,1.289-5.7,4.181-6.283c2.875-0.573,5.704,1.29,6.284,4.181c1.858,9.241,3.16,18.711,3.87,28.142 c0.221,2.94-1.982,5.502-4.922,5.726c-0.257,0.019-0.516,0.017-0.768,0C1603.445,3012.674,1601.3,3010.607,1601.097,3007.929z  M1590.418,2954.895c-2.857-8.541-6.281-16.99-10.178-25.121c-1.272-2.656-0.151-5.845,2.506-7.118 c2.667-1.276,5.846-0.158,7.12,2.504c4.088,8.525,7.677,17.392,10.676,26.345c0.934,2.795-0.572,5.823-3.367,6.757 c-0.682,0.225-1.377,0.309-2.053,0.263C1593.028,2958.384,1591.126,2957.007,1590.418,2954.895z M1567.035,2906.105 c-4.872-7.591-10.261-14.95-16.012-21.859c-1.886-2.269-1.578-5.634,0.689-7.517c2.261-1.879,5.628-1.578,7.515,0.686 c6.034,7.251,11.681,14.963,16.792,22.925c1.593,2.48,0.87,5.784-1.61,7.377c-1.002,0.638-2.135,0.906-3.237,0.831 C1569.541,2908.438,1567.984,2907.585,1567.035,2906.105z M1532.448,2864.503c-6.568-6.175-13.579-11.999-20.841-17.317 c-2.377-1.738-2.892-5.08-1.151-7.459s5.081-2.9,7.459-1.151c7.61,5.572,14.959,11.679,21.845,18.147 c2.146,2.021,2.252,5.397,0.234,7.543c-1.14,1.213-2.714,1.775-4.253,1.671 C1534.553,2865.857,1533.384,2865.381,1532.448,2864.503z M1488.811,2832.557c-7.865-4.387-16.077-8.323-24.413-11.698 c-2.73-1.104-4.05-4.218-2.943-6.948c1.107-2.73,4.208-4.046,6.951-2.946c8.74,3.538,17.357,7.668,25.607,12.27 c2.572,1.438,3.496,4.687,2.061,7.259c-1.04,1.862-3.03,2.862-5.024,2.727 C1490.287,2833.169,1489.524,2832.955,1488.811,2832.557z M1438.708,2812.261c-8.674-2.316-17.61-4.117-26.561-5.35 c-2.919-0.406-4.959-3.099-4.555-6.018c0.401-2.919,3.085-4.916,6.018-4.561c9.383,1.299,18.752,3.187,27.849,5.615 c2.848,0.762,4.541,3.687,3.781,6.535c-0.668,2.504-3.016,4.116-5.511,3.947 C1439.39,2812.406,1439.049,2812.352,1438.708,2812.261z M1352.164,2801.409c-0.319-2.931,1.797-5.562,4.729-5.881 c8.112-0.882,16.412-1.333,24.645-1.346c1.252-0.009,2.497,0.002,3.744,0.019c2.933-0.042,5.302,2.469,5.251,5.423 c-0.046,2.948-2.471,5.296-5.42,5.254c-1.169-0.021-2.341-0.028-3.535-0.02c-7.881,0.01-15.798,0.44-23.533,1.28 c-0.319,0.036-0.635,0.041-0.942,0.02C1354.567,2805.986,1352.446,2804.02,1352.164,2801.409z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062154364428616130800000016096618211498886288_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.6152,
    y1: 1409.4789,
    x2: 583.5854,
    y2: 1409.4789,
    gradientTransform: "matrix(0.9914 0.1306 -0.1306 0.9914 1084.3943 1734.7203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062154364428616130800000016096618211498886288_)"
    },
    d: "M1363.131,3254.426 c-9.271-0.748-18.576-2.073-27.661-3.925c-2.885-0.592-4.75-3.409-4.16-6.299c0.59-2.891,3.425-4.72,6.299-4.16 c8.661,1.771,17.537,3.031,26.383,3.745c2.938,0.235,5.127,2.812,4.889,5.748c-0.236,2.914-2.771,5.094-5.678,4.897 C1363.18,3254.429,1363.154,3254.427,1363.131,3254.426z M1385.538,3249.872c-0.116-2.944,2.177-5.427,5.121-5.541 c8.859-0.351,17.787-1.24,26.536-2.649c2.894-0.457,5.649,1.51,6.115,4.426c0.469,2.91-1.51,5.644-4.421,6.115 c-9.168,1.474-18.524,2.408-27.808,2.772c-0.196,0.008-0.387,0.005-0.579-0.008 C1387.819,3254.806,1385.647,3252.627,1385.538,3249.872z M1308.472,3243.235c-8.82-2.969-17.535-6.5-25.899-10.498 c-2.659-1.272-3.785-4.461-2.514-7.118c1.269-2.662,4.445-3.779,7.115-2.517c7.979,3.816,16.29,7.184,24.704,10.02 c2.794,0.941,4.295,3.968,3.356,6.757c-0.791,2.349-3.056,3.784-5.417,3.624 C1309.37,3243.473,1308.919,3243.385,1308.472,3243.235z M1439.563,3242.455c-0.822-2.83,0.81-5.791,3.639-6.612 c8.515-2.469,16.96-5.487,25.104-8.973c2.708-1.154,5.846,0.103,7.006,2.804c1.159,2.711-0.096,5.849-2.807,7.008 c-8.54,3.658-17.401,6.825-26.331,9.413c-0.618,0.177-1.241,0.24-1.847,0.198 C1442.155,3246.146,1440.205,3244.666,1439.563,3242.455z M1258.156,3219.175c-7.83-4.991-15.435-10.515-22.61-16.418 c-2.276-1.873-2.602-5.238-0.729-7.514c1.873-2.276,5.236-2.608,7.514-0.729c6.84,5.635,14.095,10.9,21.564,15.658 c2.484,1.584,3.217,4.883,1.63,7.371c-1.084,1.703-2.98,2.583-4.865,2.455 C1259.799,3219.938,1258.937,3219.671,1258.156,3219.175z M1215.073,3183.74c-6.419-6.735-12.486-13.921-18.032-21.353 c-1.762-2.361-1.278-5.702,1.085-7.465c2.358-1.763,5.705-1.28,7.47,1.085c5.29,7.086,11.079,13.94,17.205,20.367 c2.034,2.133,1.952,5.512-0.182,7.546c-1.128,1.073-2.603,1.559-4.046,1.461 C1217.29,3185.296,1216.031,3184.745,1215.073,3183.74z M1181.712,3139.008c-4.625-8.081-8.791-16.517-12.386-25.066 c-1.142-2.72,0.135-5.847,2.852-6.989c2.715-1.144,5.844,0.139,6.987,2.849c3.426,8.156,7.4,16.198,11.813,23.899 c1.464,2.559,0.577,5.822-1.982,7.283c-0.948,0.547-1.992,0.763-3.006,0.695 C1184.269,3141.563,1182.635,3140.616,1181.712,3139.008z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075848067031910980470000007380219115779363735_",
    gradientUnits: "userSpaceOnUse",
    x1: 759.9269,
    y1: 1409.1227,
    x2: 781.42,
    y2: 1409.1227,
    gradientTransform: "matrix(-0.9977 -0.0675 -0.0675 0.9977 2364.7034 1862.0195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075848067031910980470000007380219115779363735_)"
    },
    d: "M1494.672,3224.726 c1.027,0.07,2.084-0.157,3.042-0.714c3.948-2.298,7.844-4.724,11.586-7.208c2.453-1.631,3.124-4.944,1.494-7.4 c-1.634-2.446-4.942-3.119-7.401-1.493c-3.566,2.371-7.285,4.684-11.052,6.879c-2.548,1.483-3.409,4.752-1.925,7.297 C1491.343,3223.675,1492.964,3224.61,1494.672,3224.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014603185071946323490000014850341886527090079_",
    gradientUnits: "userSpaceOnUse",
    x1: -613.1746,
    y1: 2946.719,
    x2: -92.4171,
    y2: 2408.4072,
    gradientTransform: "matrix(0.6694 0.7429 -0.7429 0.6694 3584.21 1491.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014603185071946323490000014850341886527090079_)"
    },
    d: "M1521.853,3126.826 c0.787-0.843,0.954-2.091,0.415-3.11l-15.384-29.073c7.658-13.315,13.248-27.947,16.338-43.449l30.7-11.746 c1.077-0.412,1.773-1.462,1.735-2.614l-1.317-39.43c-0.037-1.153-0.804-2.154-1.905-2.493l-31.416-9.673 c-4.117-15.262-10.67-29.489-19.199-42.264l13.41-30.033c0.47-1.053,0.22-2.288-0.621-3.076l-28.812-26.951 c-0.842-0.788-2.091-0.955-3.11-0.415l-29.071,15.384c-13.315-7.659-27.947-13.249-43.45-16.338l-11.746-30.7 c-0.412-1.077-1.462-1.774-2.614-1.735l-39.431,1.316c-1.153,0.039-2.153,0.804-2.492,1.906l-9.673,31.416 c-15.262,4.116-29.489,10.669-42.263,19.2l-30.033-13.412c-1.052-0.47-2.288-0.221-3.075,0.621l-26.952,28.813 c-0.787,0.842-0.953,2.091-0.415,3.109l15.384,29.073c-7.659,13.314-13.249,27.946-16.338,43.449l-30.7,11.746 c-1.077,0.411-1.774,1.461-1.735,2.614l1.316,39.431c0.039,1.152,0.804,2.153,1.906,2.492l31.415,9.673 c4.117,15.262,10.67,29.489,19.2,42.264l-13.411,30.033c-0.47,1.052-0.221,2.287,0.621,3.076l28.812,26.951 c0.842,0.788,2.091,0.954,3.11,0.415l29.072-15.384c13.315,7.659,27.947,13.249,43.45,16.339l11.746,30.7 c0.412,1.076,1.462,1.773,2.614,1.735l39.431-1.317c1.152-0.039,2.153-0.804,2.492-1.906l9.673-31.414 c15.262-4.117,29.489-10.671,42.263-19.2l30.033,13.411c1.052,0.47,2.288,0.22,3.075-0.622L1521.853,3126.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "#FFFFFF"
    },
    d: "M1373.304,3062.347c-10.541-2.286-19.557-8.543-25.389-17.614 c-5.833-9.066-7.784-19.865-5.493-30.404c4.724-21.75,26.231-35.574,48.021-30.881c21.752,4.731,35.603,26.272,30.876,48.017 c-2.288,10.538-8.543,19.554-17.612,25.387c-7.373,4.74-15.889,6.917-24.479,6.335 C1377.254,3063.053,1375.273,3062.773,1373.304,3062.347z M1352.852,3016.591c-1.684,7.754-0.25,15.696,4.041,22.37 c4.289,6.669,10.923,11.271,18.673,12.955l0,0c7.754,1.674,15.694,0.247,22.368-4.044c6.671-4.286,11.27-10.923,12.954-18.67 c3.476-16-6.712-31.844-22.711-35.325c-1.444-0.312-2.885-0.514-4.318-0.611 C1369.416,2992.289,1356.013,3002.038,1352.852,3016.591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.56,
      fill: "#FFFFFF"
    },
    d: "M1374.44,3122.581c3.369,0.228,6.777,0.286,10.221,0.175 c6.84-0.226,13.665-1.149,20.3-2.747c0.298-0.074,0.595-0.148,0.893-0.222c2.301-0.575,3.875-2.563,4.029-4.81 c0.037-0.546-0.011-1.108-0.151-1.666c-0.716-2.859-3.618-4.581-6.474-3.876c-6.181,1.551-12.556,2.441-18.948,2.651l-0.003,0 c-0.351,0.012-0.703,0.02-1.052,0.028c-15.134,0.36-29.784-3.066-42.902-9.804c-7.12-3.658-13.791-8.299-19.837-13.854 c-0.049-0.045-0.098-0.09-0.148-0.135c-0.15-0.141-0.3-0.277-0.447-0.417c-17.528-16.398-27.625-38.64-28.425-62.629 c-0.106-3.105-0.051-6.189,0.156-9.246c1.395-20.571,9.754-39.876,24.029-55.14c16.398-17.528,38.64-27.62,62.627-28.42 c23.973-0.791,46.855,7.789,64.386,24.183c17.528,16.398,27.625,38.64,28.425,62.629c0.104,3.052,0.049,6.1-0.156,9.126 c-0.891,13.125-4.642,25.904-11.031,37.413c-0.393,0.71-0.609,1.468-0.658,2.228c-0.135,1.997,0.866,3.992,2.734,5.028 c2.581,1.423,5.825,0.504,7.258-2.079c7.148-12.878,11.347-27.179,12.346-41.858c0.229-3.39,0.29-6.797,0.177-10.211 c-0.897-26.843-12.191-51.726-31.805-70.072c-19.612-18.341-45.178-27.97-72.03-27.056 c-26.84,0.894-51.722,12.186-70.067,31.803c-15.973,17.072-25.323,38.671-26.883,61.686c-0.231,3.416-0.293,6.87-0.177,10.341 C1282.564,3077.591,1323.642,3119.142,1374.44,3122.581z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129173596410570664490000010351386531416270726_",
    gradientUnits: "userSpaceOnUse",
    x1: 4222.1016,
    y1: 1595.0436,
    x2: 4907.6177,
    y2: 2317.7146,
    gradientTransform: "matrix(0.9996 -0.0269 0.0269 0.9996 -1780.9319 2.4134)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129173596410570664490000010351386531416270726_)"
    },
    d: "M2965.067,1732.823l-589.269,3.251 c-15.26,0.084-27.789-12.044-28.199-27.299l-1.908-70.829c-0.423-15.685,12.102-28.668,27.792-28.809l589.214-5.297 c15.297-0.137,27.885,12.006,28.297,27.298l1.963,72.875C2993.38,1719.737,2980.796,1732.736,2965.067,1732.823z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2371.041,1712.881 2368.873,1632.4 2966.757,1627.405 2968.96,1709.202  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125565746997925426170000007008585525921820326_",
    gradientUnits: "userSpaceOnUse",
    x1: -2846.2917,
    y1: 954.0094,
    x2: -3123.6997,
    y2: 1968.9192,
    gradientTransform: "matrix(-0.9995 -0.0307 -0.0307 0.9995 41.6097 -0.291)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125565746997925426170000007008585525921820326_)"
    },
    d: "M3089.405,1732.071l-172.657,0.953 c-23.975,0.132-40.007-24.637-30.068-46.456l54.798-120.295c5.283-11.598,16.798-19.092,29.542-19.226l114.613-1.206 c17.927-0.189,32.693,14.034,33.175,31.956l3.247,120.548C3122.55,1716.752,3107.818,1731.969,3089.405,1732.071z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2902.718,1709.544 2966.012,1570.702 3094.279,1569.435 3098.02,1708.342  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2429.95,1700.308 2387.842,1700.582 2386.33,1644.45 2428.437,1644.113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2487.169,1699.938 2444.928,1700.211 2443.414,1643.993 2485.653,1643.654  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2544.566,1699.565 2502.193,1699.84 2500.677,1643.533 2543.048,1643.194  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121982451439778736420000015636063216773648297_",
    gradientUnits: "userSpaceOnUse",
    x1: -2567.3147,
    y1: 1461.2808,
    x2: -2630.4646,
    y2: 1849.2012,
    gradientTransform: "matrix(-0.9995 -0.0307 -0.0307 0.9995 41.6097 -0.291)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121982451439778736420000015636063216773648297_)"
    },
    points: "2602.143,1699.192  2559.637,1699.468 2558.119,1643.073 2600.622,1642.732  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068664070401808634780000013366712827814486954_",
    gradientUnits: "userSpaceOnUse",
    x1: 4408.6709,
    y1: 1527.8517,
    x2: 4329.7314,
    y2: 2091.7046,
    gradientTransform: "matrix(0.9996 -0.0269 0.0269 0.9996 -1780.9319 2.4134)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000068664070401808634780000013366712827814486954_)"
    },
    points: "2659.901,1698.817  2617.262,1699.093 2615.741,1642.61 2658.378,1642.268  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085950178207206219750000009158560420142258306_",
    gradientUnits: "userSpaceOnUse",
    x1: 4465.5786,
    y1: 1535.818,
    x2: 4386.6392,
    y2: 2099.6702,
    gradientTransform: "matrix(0.9996 -0.0269 0.0269 0.9996 -1780.9319 2.4134)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085950178207206219750000009158560420142258306_)"
    },
    points: "2717.841,1698.442  2675.067,1698.719 2673.544,1642.147 2716.315,1641.804  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096744283373815609740000013510452362087163527_",
    gradientUnits: "userSpaceOnUse",
    x1: 4522.666,
    y1: 1543.8092,
    x2: 4443.7266,
    y2: 2107.6619,
    gradientTransform: "matrix(0.9996 -0.0269 0.0269 0.9996 -1780.9319 2.4134)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000096744283373815609740000013510452362087163527_)"
    },
    points: "2775.963,1698.064  2733.055,1698.343 2731.529,1641.682 2774.435,1641.338  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124144543458130423530000004574054329118014358_",
    gradientUnits: "userSpaceOnUse",
    x1: 4579.9326,
    y1: 1551.8253,
    x2: 4500.9937,
    y2: 2115.6775,
    gradientTransform: "matrix(0.9996 -0.0269 0.0269 0.9996 -1780.9319 2.4134)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000124144543458130423530000004574054329118014358_)"
    },
    points: "2834.268,1697.686  2791.226,1697.965 2789.697,1641.215 2832.738,1640.87  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114063142955419597600000011360516237193117606_",
    gradientUnits: "userSpaceOnUse",
    x1: 1294.0958,
    y1: 1468.9689,
    x2: -152.772,
    y2: 4362.6982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114063142955419597600000011360516237193117606_)"
    },
    d: "M1397.765,2390.174H575.17 c-4.142,0-7.5-3.358-7.5-7.5v-596.899c0-4.142,3.358-7.5,7.5-7.5h822.594c4.142,0,7.5,3.358,7.5,7.5v596.899 C1405.265,2386.816,1401.907,2390.174,1397.765,2390.174z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090981229306068721900000013128617354460917410_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.3637,
    y1: 2591.0803,
    x2: -658.2377,
    y2: 1898.8392,
    gradientTransform: "matrix(1 0 0 1 991.2073 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000090981229306068721900000013128617354460917410_)"
    },
    points: "661.789,1970.827  626.257,1968.318 581.934,2098.074 640.04,2389.321 695.175,2381.188  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091724340583482068490000010968605692111043242_",
    gradientUnits: "userSpaceOnUse",
    x1: 826.42,
    y1: 2075.0891,
    x2: 553.1202,
    y2: 2546.0955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000091724340583482068490000010968605692111043242_)"
    },
    points: "873.786,2368.816  803.589,2102.702 761.683,1958.626 661.789,1970.827 615.826,2104.811 678.935,2381.152 873.957,2381.152  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067952409619721179990000007444599299613326783_",
    gradientUnits: "userSpaceOnUse",
    x1: -162.2953,
    y1: 2082.8337,
    x2: -390.9796,
    y2: 1880.5536,
    gradientTransform: "matrix(1 0 0 1 991.2073 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000067952409619721179990000007444599299613326783_)"
    },
    points: "626.257,1968.318  715.693,1955.371 761.683,1958.626 661.789,1970.827  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005955216485524386910000006271134536222624947_",
    gradientUnits: "userSpaceOnUse",
    x1: -235.3375,
    y1: 2135.2078,
    x2: -373.3994,
    y2: 2013.0865,
    gradientTransform: "matrix(1 0 0 1 991.2073 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000005955216485524386910000006271134536222624947_)"
    },
    points: "646.358,2098.206  695.271,2082.844 695.271,2021.74 670.815,2023.911  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091009984001616430220000008630263517486249641_",
    gradientUnits: "userSpaceOnUse",
    x1: -131.6182,
    y1: 2137.6067,
    x2: -307.0969,
    y2: 1982.389,
    gradientTransform: "matrix(1 0 0 1 991.2073 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000091009984001616430220000008630263517486249641_)"
    },
    points: "735.639,2014.059  758,2008.407 778.318,2075.856 745.303,2075.856  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018194831898655058480000013150470533038408611_",
    gradientUnits: "userSpaceOnUse",
    x1: 1127.0045,
    y1: 1944.2118,
    x2: 994.3853,
    y2: 2525.874
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018194831898655058480000013150470533038408611_)"
    },
    d: "M1106.184,2311.538 c-61.175,7.092-47.467-92.024-46.576-95.986l-89.523,70.947c0,0,7.829,52.167,86.802,75.396 c19.98,5.876,37.907,5.194,53.554,0.916C1102.601,2343.493,1102.998,2325.748,1106.184,2311.538z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115474681899399435180000012374782446533618614_",
    gradientUnits: "userSpaceOnUse",
    x1: 1409.1906,
    y1: 2341.5466,
    x2: 1571.2345,
    y2: 2341.5466,
    gradientTransform: "matrix(0.9985 -0.0552 0.0552 0.9985 -433.0456 58.8591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115474681899399435180000012374782446533618614_)"
    },
    d: "M1223.236,2275.467 c-23.752-14.646-48.785,2.695-48.785,2.695c-29.477,21.69-51.633,31.448-68.268,33.376 c-3.187,14.21-3.583,31.955,4.256,51.273c33.854-9.257,56.995-35.407,66.943-48.718c3.581-4.792,10.328-5.963,15.22-2.521 c4.971,3.497,9.88,8.391,9.341,13.858c-1.063,10.78,11.527,13.492,12.249,9.565c0.721-3.928-5.726-26.622-5.726-26.622 s26.183,23.574,36.396,32.624c10.213,9.051,21.86-1.208,21.86-1.208S1246.988,2290.114,1223.236,2275.467z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181783003964854799650000003866652389307173762_",
    gradientUnits: "userSpaceOnUse",
    x1: 992.534,
    y1: 2054.6118,
    x2: 687.7429,
    y2: 2575.7815
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181783003964854799650000003866652389307173762_)"
    },
    d: "M806.186,2077.655 c0,0,87.321-40.687,261.084,87.33c0,0,15.468,27.965,1.738,54.376c-13.73,26.411-97.675,94.982-113.688,165.182 c0,0-53.193,8.55-230.439,9.122C724.881,2393.664,722.112,2227.154,806.186,2077.655z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057129623965661155550000005801102492814732685_",
    gradientUnits: "userSpaceOnUse",
    x1: 1254.5848,
    y1: 2102.3943,
    x2: 1362.1005,
    y2: 2102.3943,
    gradientTransform: "matrix(0.9985 -0.0552 0.0552 0.9985 -433.0456 58.8591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057129623965661155550000005801102492814732685_)"
    },
    d: "M980.952,2035.995l-41.014,55.719 c-4.072,5.532-4.627,12.946-1.268,18.938c6.789,12.109,22.267,29.429,54.236,25.15c9.51-1.273,17.65-7.504,21.345-16.359 l27.226-65.237L980.952,2035.995z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004529017040374287490000017604239180627212191_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.6363,
    y1: 1986.2476,
    x2: 570.8458,
    y2: 2507.4165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004529017040374287490000017604239180627212191_)"
    },
    d: "M749.661,2309.707 c-12.699-41.645,87.102-141.567,87.102-141.567l-30.577-90.485c0,0-218.392,163.464-153.906,281.65 c9.245,16.943,20.919,28.524,34.124,35.969C701.946,2345.122,729.796,2320.977,749.661,2309.707z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006680354309420728830000000872343453369073060_",
    gradientUnits: "userSpaceOnUse",
    x1: 942.7907,
    y1: 1672.4119,
    x2: 705.984,
    y2: 2538.447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006680354309420728830000000872343453369073060_)"
    },
    d: "M749.248,2303.564 c-1.115,0.062-2.17-0.638-2.511-1.757c-12.985-42.579,83.605-139.921,87.721-144.046c0.967-0.967,2.538-0.973,3.515-0.003 c0.971,0.97,0.97,2.545,0.003,3.515c-0.989,0.988-98.608,99.336-86.486,139.085c0.4,1.313-0.34,2.701-1.652,3.101 C749.644,2303.52,749.445,2303.554,749.248,2303.564z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148640878054683552680000011344442272547210400_",
    gradientUnits: "userSpaceOnUse",
    x1: 1181.2589,
    y1: 2343.4871,
    x2: 769.6501,
    y2: 3058.7417,
    gradientTransform: "matrix(0.9985 -0.0552 0.0552 0.9985 -433.0456 58.8591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148640878054683552680000011344442272547210400_)"
    },
    d: "M908.498,2297.287 c0,0-121.821,55.212-154.216,20.535c-2.197-2.352-3.696-5.085-4.62-8.115c-19.865,11.27-47.715,35.415-63.257,85.567 c67.787,38.221,176.104-33.076,205.305-53.944c4.804-3.433,10.714-4.87,16.553-3.992c11.805,1.775,32.165,4.22,42.946,1.944 c15.774-3.329,41.724,51.524,66.552,32.791C1017.761,2372.074,990.292,2275.751,908.498,2297.287z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014601846711928725830000003996547998736135346_",
    gradientUnits: "userSpaceOnUse",
    x1: 1649.8002,
    y1: 591.8948,
    x2: 1515.3845,
    y2: 769.7159,
    gradientTransform: "matrix(0.953 -0.3029 0.3029 0.953 -704.1665 1896.8171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014601846711928725830000003996547998736135346_)"
    },
    d: "M1072.277,1952.436 c0.537,1.688-3.774,118.773-3.774,118.773l-66.801-3.882l-12.401-111.579 C989.301,1955.748,1063.289,1924.163,1072.277,1952.436z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147924315288865346570000003928433594260093588_",
    gradientUnits: "userSpaceOnUse",
    x1: 1547.1425,
    y1: 634.7899,
    x2: 1707.7021,
    y2: 634.7899,
    gradientTransform: "matrix(0.953 -0.3029 0.3029 0.953 -704.1665 1896.8171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147924315288865346570000003928433594260093588_)"
    },
    d: "M1007.872,1977.987l1.929,59.248 c0.025,0.76,0.147,1.494,0.377,2.219c1.404,4.436,7.352,19.345,22.234,12.329c13.504-6.366,25.923-11.975,35.352-10.72 c4.234,0.564,7.343,4.241,7.185,8.51c-0.395,10.638-1.726,34.593-6.059,55.228c-0.879,4.188-4.844,6.968-9.092,6.459 c-12.801-1.533-39.71-5.521-60.607-13.801c-2.831-1.122-4.829-3.667-5.201-6.69c-1.812-14.737-7.485-59.508-10.996-71.739 c-3.295-11.48-18.824-16.108-25.483-17.586c-2.184-0.485-4.055-1.83-5.213-3.744c-4.093-6.763-10.859-22.861,9.121-33.235 c4.181-2.171,5.72-7.324,3.423-11.437c-4.573-8.19-8.099-21.261,7.025-31.296c15.372-10.2,29.245-3.405,37.135,2.678 c3.191,2.46,7.61,2.182,10.617-0.499c1.712-1.526,4.11-2.332,7.395-0.971c4.426,1.833,9.456-0.752,10.821-5.345 c2.623-8.823,9.276-18.913,25.997-18.828c29.671,0.152,38.246,31.579,33.745,51.577c-4.501,19.998-36.66,18.005-53.767,11.14 c-13.006-5.22-27.082,4.851-33.082,9.978C1008.829,1973.087,1007.79,1975.489,1007.872,1977.987z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021822228036233102380000001886585183367055806_",
    gradientUnits: "userSpaceOnUse",
    x1: 1452.9353,
    y1: 732.7176,
    x2: 1560.7463,
    y2: 622.1063,
    gradientTransform: "matrix(0.953 -0.3029 0.3029 0.953 -704.1665 1896.8171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021822228036233102380000001886585183367055806_)"
    },
    d: "M983.911,2040.597 c0,0,6.347-35.182-7.189-41.293c-13.536-6.111-30.883,1.108-22.915,24.509 C963.719,2052.92,983.911,2040.597,983.911,2040.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1071.043,1962.069c-0.449,0-0.823-0.35-0.844-0.803c-0.023-0.466,0.335-0.866,0.803-0.889 c0.872-0.043,21.386-1.265,21.728-18.068c0.235-11.493-4.837-20.849-9.662-25.775c-2.611-2.663-5.34-4.255-7.299-4.255 c-0.467,0-0.846-0.38-0.846-0.846c0-0.466,0.378-0.846,0.846-0.846c2.44,0,5.542,1.738,8.509,4.764 c5.064,5.17,10.388,14.976,10.144,26.991c-0.375,18.385-23.108,19.713-23.337,19.726 C1071.071,1962.069,1071.056,1962.069,1071.043,1962.069z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049205895650287024530000017244060160853204353_",
    gradientUnits: "userSpaceOnUse",
    x1: 1261.7771,
    y1: 2116.3823,
    x2: 1323.3472,
    y2: 2074.6399,
    gradientTransform: "matrix(0.9926 -0.1214 0.1214 0.9926 -539.9148 138.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049205895650287024530000017244060160853204353_)"
    },
    d: "M1036.538,2075.976 c-41.05,1.114-62.78-42.325-62.995-42.765l2.812-1.376c0.206,0.421,21.078,42.07,60.098,41.011L1036.538,2075.976z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144337409078423681810000005310655970375273367_",
    gradientUnits: "userSpaceOnUse",
    x1: 1015.3835,
    y1: 2097.041,
    x2: 1055.1563,
    y2: 2062.3342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144337409078423681810000005310655970375273367_)"
    },
    d: "M1047.808,2078.994h-14.565 c-0.614,0-1.115-0.502-1.115-1.115v-5.555c0-0.614,0.502-1.115,1.115-1.115h14.565c0.613,0,1.115,0.502,1.115,1.115v5.555 C1048.923,2078.492,1048.422,2078.994,1047.808,2078.994z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173862445136764439160000005861458297288458421_",
    gradientUnits: "userSpaceOnUse",
    x1: 1454.839,
    y1: 1966.7771,
    x2: 1019.0754,
    y2: 2038.7727,
    gradientTransform: "matrix(0.9926 -0.1214 0.1214 0.9926 -539.9148 138.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173862445136764439160000005861458297288458421_)"
    },
    d: "M975.396,1992.049 c0,0,17.934-64.619,58.977-69.366c0,0-11.175-5.726-23.544-0.356c-12.369,5.37-44.719,36.013-45.7,70.977 C973.208,1996.32,975.396,1992.049,975.396,1992.049z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162347986321729645250000008001049977657005727_",
    gradientUnits: "userSpaceOnUse",
    x1: 1352.2189,
    y1: 2036.6033,
    x2: 1112.1907,
    y2: 2076.26,
    gradientTransform: "matrix(0.9926 -0.1214 0.1214 0.9926 -539.9148 138.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162347986321729645250000008001049977657005727_)"
    },
    d: "M971.287,1982.506 c-22.705,3.477-21.314,32.044-21.314,32.044c-2.617,20.557,2.911,31.076,10.393,36.323 c5.111,3.584,11.734,4.213,17.436,1.673c5.702-2.541,9.656-7.885,10.415-14.081c0.687-5.596,1.42-10.911,1.929-12.786 C991.377,2021.135,993.992,1979.028,971.287,1982.506z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100357183255572782040000012901468094693226922_",
    gradientUnits: "userSpaceOnUse",
    x1: 1022.2535,
    y1: 1951.8539,
    x2: 1124.626,
    y2: 1823.8882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100357183255572782040000012901468094693226922_)"
    },
    d: "M973.005,1989.796 c-4.628-1.037-9.352,1.221-11.439,5.48c-14.941,30.481,0.58,51.527,8.659,52.341c8.516,0.857,10.326-40.222,9.022-50.839 C978.7,1992.328,975.981,1990.462,973.005,1989.796z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069357018669091946740000011891455220142251654_",
    gradientUnits: "userSpaceOnUse",
    x1: -26.2843,
    y1: 2473.7185,
    x2: 219.0345,
    y2: 2352.6943,
    gradientTransform: "matrix(1 0 0 1 991.2073 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069357018669091946740000011891455220142251654_)"
    },
    d: "M1304.448,2375.013H975.536 c-7.15,0-10.407,8.711-10.407,15.862v3.197h352.597v-3.197C1317.726,2383.724,1311.599,2375.013,1304.448,2375.013z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044166082246335137170000015947763505923289263_",
    gradientUnits: "userSpaceOnUse",
    x1: 1289.6376,
    y1: 2201.9021,
    x2: 964.8738,
    y2: 2607.8567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044166082246335137170000015947763505923289263_)"
    },
    d: "M1435.711,2135.282l-42.175,245.541 c-1.377,8.02-1.068,14.911-19.828,14.523l-315.759-0.008c-10.087,0-16.796-6.663-14.988-14.905l55.319-252.143 c1.683-7.671,10.871-13.72,20.528-13.509l302.605,6.597C1430.608,2121.579,1436.996,2127.805,1435.711,2135.282z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049915563533330429470000016479456669689102217_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.0876,
    y1: 2483.6851,
    x2: 91.0125,
    y2: 2148.7485,
    gradientTransform: "matrix(1 0 0 1 991.2073 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049915563533330429470000016479456669689102217_)"
    },
    d: "M1126.412,2119.399l-58.288,270.219 c-0.726,3.366-5.392,6.116-9.49,6.116c-10.086,0-22.095,2.592-15.731-15.035l55.36-252.333 c1.692-7.712,10.887-13.795,20.544-13.585l5.311,0.116C1125.81,2115.936,1126.802,2117.589,1126.412,2119.399z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1384.28,2295.948c-1.173-0.036-1.95-0.906-1.735-1.942l30.168-145.479 c1.369-6.602-4.776-10.844-11.513-11.135l-32.073-1.39c-1.153-0.05-1.916-0.897-1.703-1.892 c0.213-0.995,1.32-1.76,2.473-1.71l32.054,1.399c10.007,0.437,16.551,6.977,14.912,14.906l-30.073,145.434 C1386.577,2295.173,1385.453,2295.984,1384.28,2295.948z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111178075549782511630000011944038947251232137_",
    gradientUnits: "userSpaceOnUse",
    x1: -4524.915,
    y1: 1353.1996,
    x2: -4524.915,
    y2: 2206.6736,
    gradientTransform: "matrix(-1 0 0 1 -3533.4106 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111178075549782511630000011944038947251232137_)"
    },
    d: "M632.535,1739.006l714.292-1.144 c7.582-0.012,13.785-6.04,14.015-13.618l3.693-121.875c0.241-7.942-6.15-14.502-14.096-14.469l-714.348,2.995 c-7.568,0.032-13.749,6.054-13.978,13.618l-3.637,120.025C618.235,1732.465,624.603,1739.019,632.535,1739.006z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1333.627,1710.459 1336.507,1615.382 648.663,1617.94 645.816,1711.886  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109008693110617894580000017163979961090721197_",
    gradientUnits: "userSpaceOnUse",
    x1: -4152.2769,
    y1: 1353.1997,
    x2: -4152.2769,
    y2: 2206.8633,
    gradientTransform: "matrix(-1 0 0 1 -3533.4106 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109008693110617894580000017163979961090721197_)"
    },
    d: "M505.962,1739.134l256.139-0.411 l-88.322-199.242c-3.727-8.409-12.081-13.811-21.279-13.762l-150.873,0.804c-11.431,0.061-20.762,9.162-21.109,20.588 l-4.874,160.825C475.128,1725.03,488.859,1739.162,505.962,1739.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M711.991,1693.289l-58.758-132.625c-2.109-4.76-6.836-7.82-12.042-7.795l-121.396,0.59 c-7.057,0.034-12.819,5.651-13.032,12.705l-4.013,132.417c-0.224,7.399,5.721,13.514,13.123,13.499l184.167-0.383 C709.502,1711.679,715.824,1701.941,711.991,1693.289z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1264.168,1696.223 1313.812,1696.108 1315.819,1629.851 1266.174,1630.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1197.03,1696.379 1246.558,1696.264 1248.563,1630.084 1199.034,1630.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1130.048,1696.535 1179.461,1696.419 1181.464,1630.317 1132.049,1630.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1063.221,1696.69 1112.519,1696.575 1114.52,1630.549 1065.22,1630.72  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009581666128430250720000015379132804352589477_",
    gradientUnits: "userSpaceOnUse",
    x1: -2732.9895,
    y1: 1264.1292,
    x2: -2732.9895,
    y2: 2094.1809,
    gradientTransform: "matrix(-0.9995 -0.0303 -0.0303 0.9995 -1662.3195 25.2381)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000009581666128430250720000015379132804352589477_)"
    },
    points: "996.549,1696.845  1045.733,1696.73 1047.732,1630.781 998.546,1630.952  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127033450937087642510000016739582159502291361_",
    gradientUnits: "userSpaceOnUse",
    x1: -2666.447,
    y1: 1264.13,
    x2: -2666.447,
    y2: 2094.1819,
    gradientTransform: "matrix(-0.9995 -0.0303 -0.0303 0.9995 -1662.3195 25.2381)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127033450937087642510000016739582159502291361_)"
    },
    points: "930.031,1697  979.101,1696.885 981.097,1631.012 932.025,1631.182  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168831261594775057680000012530907769142667417_",
    gradientUnits: "userSpaceOnUse",
    x1: -2600.0588,
    y1: 1264.1306,
    x2: -2600.0588,
    y2: 2094.1819,
    gradientTransform: "matrix(-0.9995 -0.0303 -0.0303 0.9995 -1662.3195 25.2381)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000168831261594775057680000012530907769142667417_)"
    },
    points: "863.667,1697.154  912.624,1697.04 914.618,1631.243 865.659,1631.412  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066495611466026688750000002083833630053489332_",
    gradientUnits: "userSpaceOnUse",
    x1: -2533.8235,
    y1: 1264.1316,
    x2: -2533.8235,
    y2: 2094.1841,
    gradientTransform: "matrix(-0.9995 -0.0303 -0.0303 0.9995 -1662.3195 25.2381)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000066495611466026688750000002083833630053489332_)"
    },
    points: "797.456,1697.308  846.3,1697.194 848.291,1631.473 799.445,1631.643  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M1811.516,1523.602l8.171,298.844c0.922,33.713,40.208,51.623,66.262,30.208 l229.46-165.747c23.035-18.934,18.434-55.42-8.581-68.042l-237.63-133.096C1841.883,1473.006,1810.692,1493.465,1811.516,1523.602 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057133765775024967040000006090854081704779701_",
    gradientUnits: "userSpaceOnUse",
    x1: 2452.9309,
    y1: 825.9346,
    x2: 2654.4355,
    y2: 825.9346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057133765775024967040000006090854081704779701_)"
    },
    d: "M2529.897,935.783 c-1.14,0-2.252-0.464-3.057-1.319l-72.759-76.958c-0.807-0.851-1.22-2.005-1.14-3.176l6.997-102.141 c0.123-1.804,1.385-3.324,3.133-3.784l123.131-32.183c1.662-0.435,3.429,0.185,4.45,1.573l62.962,85.352 c0.7,0.953,0.972,2.153,0.742,3.312l-19.588,99.346c-0.31,1.582-1.497,2.843-3.052,3.254l-100.744,26.582 C2530.616,935.738,2530.254,935.783,2529.897,935.783z M2461.462,853.065l69.776,73.807l95.784-25.277l18.719-94.942 l-60.168-81.568l-117.447,30.7L2461.462,853.065z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115503949666910725650000013824989077581738634_",
    gradientUnits: "userSpaceOnUse",
    x1: 2452.9297,
    y1: 787.4539,
    x2: 2591.4739,
    y2: 787.4539
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115503949666910725650000013824989077581738634_)"
    },
    d: "M2457.135,858.825 c-1.814,0-3.488-1.183-4.031-3.007c-0.661-2.231,0.608-4.573,2.835-5.235l94.41-28.045l32.906-103.517 c0.705-2.218,3.081-3.447,5.284-2.736c2.214,0.703,3.438,3.069,2.736,5.284l-33.582,105.641 c-0.423,1.331-1.475,2.362-2.812,2.761l-96.546,28.682C2457.937,858.768,2457.532,858.825,2457.135,858.825z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029733789201407961590000012985156614108290194_",
    gradientUnits: "userSpaceOnUse",
    x1: 2549.4768,
    y1: 865.4652,
    x2: 2634.8474,
    y2: 865.4652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029733789201407961590000012985156614108290194_)"
    },
    d: "M2630.64,909.201 c-1.095,0-2.19-0.428-3.016-1.274l-76.957-79.058c-1.619-1.664-1.584-4.326,0.08-5.949c1.668-1.619,4.328-1.582,5.951,0.082 l76.957,79.058c1.619,1.664,1.584,4.326-0.08,5.949C2632.756,908.806,2631.699,909.201,2630.64,909.201z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070090742054904428720000016099774734350293395_",
    gradientUnits: "userSpaceOnUse",
    x1: 1347.7236,
    y1: 739.3756,
    x2: 1522.7659,
    y2: 739.3756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070090742054904428720000016099774734350293395_)"
    },
    d: "M1414.733,834.74 c-1.156,0-2.283-0.471-3.1-1.338l-62.743-66.364c-0.819-0.863-1.237-2.034-1.156-3.221l6.031-88.081 c0.125-1.829,1.404-3.371,3.177-3.838l106.181-27.75c1.692-0.437,3.475,0.188,4.513,1.596l54.296,73.601 c0.711,0.963,0.986,2.184,0.752,3.359l-16.892,85.668c-0.314,1.604-1.518,2.883-3.096,3.3l-86.875,22.926 C1415.462,834.694,1415.095,834.74,1414.733,834.74z M1356.375,762.534l59.718,63.168l81.845-21.6l16.011-81.201l-51.464-69.764 l-100.416,26.246L1356.375,762.534z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152983725001655681990000007252773821303358367_",
    gradientUnits: "userSpaceOnUse",
    x1: 1347.7225,
    y1: 706.1934,
    x2: 1468.4701,
    y2: 706.1934
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152983725001655681990000007252773821303358367_)"
    },
    d: "M1351.988,768.376 c-1.84,0-3.537-1.2-4.088-3.05c-0.671-2.258,0.616-4.638,2.875-5.308l81.087-24.088l28.273-88.943 c0.713-2.246,3.123-3.488,5.359-2.775c2.246,0.713,3.488,3.113,2.775,5.358l-28.959,91.097c-0.429,1.35-1.496,2.396-2.852,2.8 l-83.254,24.733C1352.8,768.318,1352.39,768.376,1351.988,768.376z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150060758804466675840000011721722562778730664_",
    gradientUnits: "userSpaceOnUse",
    x1: 1430.9772,
    y1: 773.463,
    x2: 1505.8734,
    y2: 773.463
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150060758804466675840000011721722562778730664_)"
    },
    d: "M1501.607,811.814 c-1.111,0-2.221-0.433-3.056-1.291l-66.364-68.172c-1.644-1.688-1.609-4.387,0.079-6.033c1.692-1.638,4.39-1.604,6.034,0.083 l66.364,68.172c1.644,1.688,1.608,4.388-0.079,6.033C1503.753,811.41,1502.68,811.814,1501.607,811.814z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064338797599214408830000002861919910001090693_",
    gradientUnits: "userSpaceOnUse",
    x1: 1999.7686,
    y1: 887.0154,
    x2: 2117.1316,
    y2: 887.0154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064338797599214408830000002861919910001090693_)"
    },
    d: "M2111.029,944.519 c-0.737,0-1.478-0.131-2.185-0.405l-105.156-40.334c-2.11-0.811-3.6-2.712-3.874-4.953c-0.275-2.241,0.709-4.452,2.56-5.746 l89.31-62.465c1.732-1.21,3.958-1.442,5.898-0.614c1.938,0.828,3.311,2.599,3.633,4.685l15.846,102.798 c0.331,2.152-0.507,4.316-2.199,5.68C2113.759,944.054,2112.4,944.519,2111.029,944.519z M2018.786,896.496l84.608,32.454 l-12.75-82.712L2018.786,896.496z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070836679230189413130000007026438424333489329_",
    gradientUnits: "userSpaceOnUse",
    x1: 1738.6907,
    y1: 586.0776,
    x2: 1855.5765,
    y2: 586.0776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070836679230189413130000007026438424333489329_)"
    },
    d: "M1743.884,656.099 c-0.974,0-1.945-0.274-2.797-0.816c-1.56-0.999-2.47-2.749-2.392-4.6l5.533-129.655c0.082-1.917,1.217-3.636,2.949-4.463 c1.735-0.832,3.783-0.634,5.328,0.512l100.967,74.679c1.443,1.065,2.232,2.8,2.087,4.59c-0.142,1.79-1.199,3.378-2.794,4.199 l-106.501,54.976C1745.517,655.907,1744.7,656.099,1743.884,656.099z M1754.189,531.242l-4.734,110.946l91.131-47.044 L1754.189,531.242z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101088371423680683560000002050243189018344072_",
    gradientUnits: "userSpaceOnUse",
    x1: 2208.437,
    y1: 632.8969,
    x2: 2277.4021,
    y2: 632.8969
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101088371423680683560000002050243189018344072_)"
    },
    d: "M2242.92,667.38 c-19.013,0-34.483-15.47-34.483-34.483c0-19.012,15.47-34.482,34.483-34.482c19.012,0,34.482,15.47,34.482,34.482 C2277.402,651.909,2261.932,667.38,2242.92,667.38z M2242.92,609.645c-12.821,0-23.252,10.43-23.252,23.251 c0,12.821,10.431,23.252,23.252,23.252s23.251-10.431,23.251-23.252C2266.171,620.075,2255.741,609.645,2242.92,609.645z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078729940657830834740000000149212203617217447_",
    gradientUnits: "userSpaceOnUse",
    x1: 1629.4648,
    y1: 859.5649,
    x2: 1706.5215,
    y2: 859.5649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B37CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F895E7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078729940657830834740000000149212203617217447_)"
    },
    d: "M1667.993,898.091 c-21.245,0-38.528-17.283-38.528-38.526c0-21.243,17.283-38.527,38.528-38.527c21.245,0,38.528,17.284,38.528,38.527 C1706.521,880.808,1689.238,898.091,1667.993,898.091z M1667.993,829.355c-16.658,0-30.211,13.552-30.211,30.21 c0,16.658,13.553,30.209,30.211,30.209c16.658,0,30.212-13.551,30.212-30.209 C1698.205,842.907,1684.651,829.355,1667.993,829.355z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090257830287153693110000001531796446790420413_",
    gradientUnits: "userSpaceOnUse",
    x1: -690.2991,
    y1: 2832.3523,
    x2: -1865.3578,
    y2: 1792.9675,
    gradientTransform: "matrix(-1 0 0 1 1583.2321 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA342D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3A84A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000090257830287153693110000001531796446790420413_)"
    },
    points: "2954.875,1901.055  3008.226,1897.288 3074.775,2092.114 2987.53,2529.415 2904.747,2517.204  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034809265352370386790000001651477325411586730_",
    gradientUnits: "userSpaceOnUse",
    x1: -1661.4177,
    y1: 2208.6772,
    x2: 83.6707,
    y2: 2179.5923,
    gradientTransform: "matrix(-1 0 0 1 1583.2321 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA342D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3A84A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000034809265352370386790000001651477325411586730_)"
    },
    points: "2636.565,2498.628  2741.966,2099.063 2804.886,1882.736 2954.875,1901.055 3023.887,2102.229 2929.131,2517.15 2636.309,2517.15  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061445529318126087240000002968912406620610229_",
    gradientUnits: "userSpaceOnUse",
    x1: -1120.7117,
    y1: 2069.2305,
    x2: -1464.0753,
    y2: 1765.5121,
    gradientTransform: "matrix(-1 0 0 1 1583.2321 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA342D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3A84A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000061445529318126087240000002968912406620610229_)"
    },
    points: "3008.226,1897.288  2873.939,1877.849 2804.886,1882.736 2954.875,1901.055  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018932100625309883690000017550626272678268589_",
    gradientUnits: "userSpaceOnUse",
    x1: -1230.3827,
    y1: 2147.8689,
    x2: -1437.6792,
    y2: 1964.5073,
    gradientTransform: "matrix(-1 0 0 1 1583.2321 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA342D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3A84A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000018932100625309883690000017550626272678268589_)"
    },
    points: "2978.044,2092.313  2904.602,2069.245 2904.602,1977.5 2941.323,1980.76  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053536925307884198770000001310013022774093467_",
    gradientUnits: "userSpaceOnUse",
    x1: -1074.6503,
    y1: 2151.4712,
    x2: -1338.1276,
    y2: 1918.4155,
    gradientTransform: "matrix(-1 0 0 1 1583.2321 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA342D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3A84A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000053536925307884198770000001310013022774093467_)"
    },
    points: "2843.99,1965.968  2810.417,1957.481 2779.909,2058.754 2829.48,2058.754  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067932890002604937850000007225745991382434475_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.4424,
    y1: 3136.6812,
    x2: 498.7606,
    y2: 3136.6812,
    gradientTransform: "matrix(-0.9985 -0.0552 -0.0552 0.9985 3007.4849 58.8591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067932890002604937850000007225745991382434475_)"
    },
    d: "M2392.102,3122.707l16.556,58.048 c2.498,8.76-1.015,18.384-8.973,22.817c-3.985,2.22-9.372,4.179-16.654,5.413c-10.277,1.74-20.496-3.527-24.869-12.988 l-21.116-45.682L2392.102,3122.707z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026881709745718086430000014929086607066404242_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.6077,
    y1: 2940.0449,
    x2: 637.425,
    y2: 2497.4031,
    gradientTransform: "matrix(-0.9985 -0.0552 -0.0552 0.9985 3007.4849 58.8591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2305,
    style: {
      stopColor: "#252A70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7285,
    style: {
      stopColor: "#19164F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026881709745718086430000014929086607066404242_)"
    },
    d: "M2612.167,2620.617 c0,0-249.864,29.22-361.449,121.429c-111.584,92.208,74.742,416.301,74.742,416.301s33.372,1.637,75.713-30.78 c0,0-107.727-241.955,0.108-304.821c121.234-70.677,256.995-80.602,256.995-80.602l-44.134-113.831L2612.167,2620.617z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006688737146822895750000012257956944848633266_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.3053,
    y1: 3130.1663,
    x2: 223.8976,
    y2: 2566.0332,
    gradientTransform: "matrix(-0.9985 -0.0552 -0.0552 0.9985 3007.4849 58.8591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006688737146822895750000012257956944848633266_)"
    },
    d: "M2854.508,2559.489 c0,0,46.844,150.007-10.589,191.665c-57.434,41.657-191.336,84.733-225.545,172.136 c-34.21,87.403-67.546,215.853-137.451,273.45c0,0-69.291,19.589-85.752,0c0,0,49.03-241.071,77.677-305.96 c24.809-56.194,61.268-137.27,124.923-180.193c18.222-12.288,16.335-33.45,9.353-54.289l-12.716-37.948L2854.508,2559.489z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044867175337243936700000016791991368172191414_",
    gradientUnits: "userSpaceOnUse",
    x1: 2578.603,
    y1: 2008.9176,
    x2: 2204.2231,
    y2: 2777.9741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044867175337243936700000016791991368172191414_)"
    },
    d: "M2287.625,2412.626 c91.853,10.648,71.271-138.173,69.933-144.12l134.417,106.525c0,0-11.755,78.328-130.331,113.205 c-30,8.823-56.917,7.799-80.41,1.375C2293.005,2460.606,2292.409,2433.962,2287.625,2412.626z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143588291676303187730000009026785210753310865_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.8492,
    y1: 2400.9597,
    x2: 827.1546,
    y2: 2400.9597,
    gradientTransform: "matrix(-0.9985 -0.0552 -0.0552 0.9985 3007.4849 58.8591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143588291676303187730000009026785210753310865_)"
    },
    d: "M2111.874,2358.466 c35.662-21.99,73.249,4.047,73.249,4.047c44.259,32.568,77.525,47.218,102.502,50.113c4.785,21.336,5.38,47.98-6.391,76.985 c-50.83-13.899-85.576-53.162-100.513-73.148c-5.377-7.195-15.507-8.953-22.853-3.785c-7.464,5.25-14.835,12.599-14.026,20.807 c1.596,16.185-17.308,20.259-18.391,14.361c-1.082-5.898,8.598-39.972,8.598-39.972s-39.314,35.396-54.649,48.984 c-15.334,13.59-32.822-1.813-32.822-1.813S2076.211,2380.458,2111.874,2358.466z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107548362695276315860000008451248266335913371_",
    gradientUnits: "userSpaceOnUse",
    x1: 2402.1687,
    y1: 2163.8574,
    x2: 3200.5427,
    y2: 2696.1072
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107548362695276315860000008451248266335913371_)"
    },
    d: "M2738.066,2061.455 c0,0-131.11-61.091-392.012,131.124c0,0-23.225,41.99-2.61,81.644c20.615,39.655,226.919,238.724,250.963,344.127 c0,0,126.749,49.069,265.72-43.005C2860.127,2575.345,2864.302,2285.925,2738.066,2061.455z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085950268998283180670000005112227951130404272_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.7118,
    y1: 2041.8774,
    x2: 513.1445,
    y2: 2041.8774,
    gradientTransform: "matrix(-0.9985 -0.0552 -0.0552 0.9985 3007.4849 58.8591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085950268998283180670000005112227951130404272_)"
    },
    d: "M2475.658,1998.903l61.582,83.661 c6.114,8.306,6.947,19.438,1.904,28.434c-10.194,18.182-33.433,44.187-81.434,37.762 c-14.278-1.911-26.501-11.267-32.049-24.562l-40.879-97.953L2475.658,1998.903z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082352331123688313060000003973793625407518087_",
    gradientUnits: "userSpaceOnUse",
    x1: 2470.3997,
    y1: 2061.5105,
    x2: 3268.7747,
    y2: 2593.7612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082352331123688313060000003973793625407518087_)"
    },
    d: "M2822.936,2409.876 c19.067-62.53-130.782-212.56-130.782-212.56l45.911-135.861c0,0,327.91,245.437,231.086,422.892 c-13.88,25.439-31.409,42.828-51.237,54.007C2894.579,2463.052,2852.763,2426.799,2822.936,2409.876z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097497474905253347500000007907776505968026248_",
    gradientUnits: "userSpaceOnUse",
    x1: 3025.6887,
    y1: 1800.2231,
    x2: 2575.7561,
    y2: 2625.6636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDF53F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D93C65"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097497474905253347500000007907776505968026248_)"
    },
    d: "M2823.557,2400.653 c1.673,0.093,3.259-0.958,3.77-2.637c19.497-63.931-125.531-210.088-131.712-216.282c-1.452-1.452-3.811-1.461-5.278-0.005 c-1.458,1.457-1.456,3.821-0.005,5.278c1.485,1.483,148.059,149.151,129.857,208.834c-0.6,1.971,0.51,4.056,2.481,4.656 C2822.963,2400.586,2823.262,2400.637,2823.557,2400.653z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142883768218268392130000014520537616995808669_",
    gradientUnits: "userSpaceOnUse",
    x1: 2876.1782,
    y1: 2452.8906,
    x2: 2411.5864,
    y2: 2500.2517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142883768218268392130000014520537616995808669_)"
    },
    d: "M2584.447,2391.227 c0,0,182.912,82.899,231.553,30.833c3.299-3.532,5.549-7.635,6.936-12.184c29.827,16.922,71.643,53.175,94.979,128.478 c-101.781,57.388-264.417-49.663-308.262-80.995c-7.213-5.154-16.087-7.313-24.854-5.994 c-17.726,2.666-48.295,6.336-64.483,2.919c-23.684-4.999-62.647,77.363-99.926,49.235 C2420.39,2503.519,2461.634,2358.893,2584.447,2391.227z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004518953642789793740000000864038868639412359_",
    gradientUnits: "userSpaceOnUse",
    x1: -2812.8672,
    y1: 2052.0144,
    x2: -2868.0488,
    y2: 1870.0126,
    gradientTransform: "matrix(-1 0 0 1 -451.021 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004518953642789793740000000864038868639412359_)"
    },
    d: "M2294.12,1953.374 c0,0,13.207,92.869,48.881,121.428c35.675,28.56,105.18,7.056,128.656-62.956l-46.776-119.707L2294.12,1953.374z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041296868856020707930000016668511970259312016_",
    gradientUnits: "userSpaceOnUse",
    x1: -3192.2515,
    y1: 2128.9983,
    x2: -2890.4341,
    y2: 1942.9941,
    gradientTransform: "matrix(-1 0 0 1 -451.021 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041296868856020707930000016668511970259312016_)"
    },
    d: "M2430.151,1969.602 c-2.713,0.874-5.555-0.865-5.978-3.684c-1.287-8.573-4.502-25.539-11.01-37.095c0,0,3.404-12.184-30.792,6.222 c-34.197,18.406-85.56,45.444-115.8,29.344c-29.483-15.697-59.348-94.698,18.571-80.062c2.965,0.557,5.691-1.805,5.469-4.814 c-0.957-12.984,0.331-42.856,30.581-52.443c28.307-8.972,13.109,5.571,19.494,13.283c1.879,2.269-2.372-7.726,37.853-1.879 c13.8,2.006,31.509-34.634,65.409-19.694c27.924,12.306,32.266,29.505,31.805,40.223c-0.149,3.473,3.375,5.826,6.532,4.372 c8.552-3.939,22.308-5.985,35.484,10.524c18.217,22.825-7.815,42.618-15.625,47.807c-1.279,0.85-2.075,2.259-2.084,3.796 c-0.074,11.87-1.922,63.646-27.872,92.852c-2.248,2.529-6.4,1.787-7.709-1.332l-19.981-47.606 c-0.928-2.211-3.394-3.344-5.676-2.609L2430.151,1969.602z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059303482014369924700000008178350325597294726_",
    gradientUnits: "userSpaceOnUse",
    x1: -2870.0237,
    y1: 2069.3445,
    x2: -2925.2056,
    y2: 1887.3417,
    gradientTransform: "matrix(-1 0 0 1 -451.021 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F47960"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059303482014369924700000008178350325597294726_)"
    },
    d: "M2429.729,1979.267 c0,0,12.201-49.696,30.736-33.561c18.534,16.135-4.832,51.647-26.064,58.417L2429.729,1979.267z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183953393467032340540000012593579761822375569_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.5688,
    y1: 2006.0748,
    x2: 497.0147,
    y2: 1943.3998,
    gradientTransform: "matrix(-0.9926 -0.1214 -0.1214 0.9926 3114.354 138.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183953393467032340540000012593579761822375569_)"
    },
    d: "M2368.516,2065.699 c61.635,1.674,94.263-63.55,94.585-64.21l-4.223-2.066c-0.31,0.631-31.649,63.168-90.236,61.578L2368.516,2065.699z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124123462772007737190000002445270047641758342_",
    gradientUnits: "userSpaceOnUse",
    x1: 3246.2666,
    y1: 2844.0549,
    x2: 3281.4971,
    y2: 2844.0549,
    gradientTransform: "matrix(0.8747 -0.1541 0.1951 1.1071 -1035.3665 -580.1812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124123462772007737190000002445270047641758342_)"
    },
    d: "M2389.207,2070.359l-27.013,4.76 c-1.046,0.184-2.052-0.521-2.237-1.566l-1.878-10.66c-0.184-1.046,0.521-2.052,1.566-2.237l27.013-4.76 c1.046-0.184,2.052,0.521,2.237,1.566l1.878,10.66C2390.958,2069.168,2390.253,2070.175,2389.207,2070.359z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017517726358557343810000013495669059554006672_",
    gradientUnits: "userSpaceOnUse",
    x1: 2429.8169,
    y1: 1866.7218,
    x2: 2296.1904,
    y2: 2260.8359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017517726358557343810000013495669059554006672_)"
    },
    d: "M2460.32,1939.685 c0,0-30.178-95.316-91.804-102.443c0,0,20.03-10.305,38.602-2.242c18.572,8.063,67.144,54.072,68.617,106.57 C2463.605,1946.099,2460.32,1939.685,2460.32,1939.685z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025407529567288681780000001828605652146415253_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.3653,
    y1: 1886.2886,
    x2: 179.9678,
    y2: 1945.8324,
    gradientTransform: "matrix(-0.9926 -0.1214 -0.1214 0.9926 3114.354 138.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025407529567288681780000001828605652146415253_)"
    },
    d: "M2466.49,1925.357 c34.091,5.221,32.002,48.114,32.002,48.114c3.929,30.865-4.372,46.66-15.606,54.538c-7.675,5.382-17.618,6.326-26.18,2.513 c-8.562-3.815-14.498-11.839-15.639-21.143c-1.03-8.402-2.131-16.382-2.895-19.198 C2436.324,1983.357,2432.399,1920.135,2466.49,1925.357z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163763548715431565560000002996845438094292125_",
    gradientUnits: "userSpaceOnUse",
    x1: 2477.3723,
    y1: 1958.4572,
    x2: 2370.8096,
    y2: 2205.4126
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163763548715431565560000002996845438094292125_)"
    },
    d: "M2463.91,1936.302 c6.949-1.557,14.041,1.834,17.175,8.228c22.434,45.766-0.87,77.367-13.001,78.589c-12.786,1.288-15.504-60.393-13.546-76.333 C2455.358,1940.105,2459.442,1937.303,2463.91,1936.302z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021096248202449166850000012046183262637124523_",
    gradientUnits: "userSpaceOnUse",
    x1: 2331.1165,
    y1: 3591.5046,
    x2: 2447.8225,
    y2: 2282.3672
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021096248202449166850000012046183262637124523_)"
    },
    d: "M1669.79,2525.712 c0,10.756,9.456,19.771,21.12,19.771h1470.439c11.664,0,21.119-9.014,21.119-19.771l0,0c0-10.756-9.455-19.771-21.119-19.771 H1690.91C1679.246,2505.941,1669.79,2514.956,1669.79,2525.712L1669.79,2525.712z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074427396000743460390000014337131123421083570_",
    gradientUnits: "userSpaceOnUse",
    x1: 2416.6504,
    y1: 2655.9019,
    x2: 2102.0518,
    y2: 4183.2285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074427396000743460390000014337131123421083570_)"
    },
    d: "M1692.138,2545.483 c39.32,213.524,78.666,424.84,117.986,637.441c2.325,12.399,13.485,22.901,24.413,22.901h1195.518 c10.928,0,22.967-10.501,25.292-22.901c39.32-212.601,78.666-423.917,117.986-637.441H1692.138z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039121549672312195850000005357051561532140433_",
    gradientUnits: "userSpaceOnUse",
    x1: 2689.8921,
    y1: 2003.3677,
    x2: 3151.6404,
    y2: 3652.4744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039121549672312195850000005357051561532140433_)"
    },
    d: "M2647.833,2545.483 c15.708,217.478,31.389,442.864,47.096,660.342h335.125c10.928,0,22.967-10.501,25.292-22.901 c39.32-212.601,78.666-423.917,117.986-637.441H2647.833z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176738986843219135140000006438271275385818017_",
    gradientUnits: "userSpaceOnUse",
    x1: 2699.365,
    y1: 3094.8794,
    x2: 3100.2246,
    y2: 2242.4182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A737D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EF497A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176738986843219135140000006438271275385818017_)"
    },
    d: "M2734.508,2525.712 c0,10.756,2.906,19.771,6.492,19.771h452.018c3.585,0,6.492-9.014,6.492-19.771l0,0c0-10.756-2.907-19.771-6.492-19.771H2741 C2737.414,2505.941,2734.508,2514.956,2734.508,2525.712L2734.508,2525.712z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130639473651017448390000006766689076626881471_",
    gradientUnits: "userSpaceOnUse",
    x1: 2174.6575,
    y1: 2304.3298,
    x2: 2158.8704,
    y2: 2521.9666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130639473651017448390000006766689076626881471_)"
    },
    d: "M1956.984,2486.171h409.428 c8.901,0,12.954,10.844,12.954,19.745v3.98h-438.91v-3.98C1940.456,2497.014,1948.083,2486.171,1956.984,2486.171z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103244207367805207130000008505135544887069317_",
    gradientUnits: "userSpaceOnUse",
    x1: -746.106,
    y1: 2248.5647,
    x2: -256.6424,
    y2: 2248.5647,
    gradientTransform: "matrix(-1 0 0 1 1583.2321 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103244207367805207130000008505135544887069317_)"
    },
    d: "M1840.079,2073.117l52.499,359.658 c1.715,11.747,12.75,21.273,24.682,21.273l393.055-0.011c12.555,0,20.908-9.759,18.657-21.833l-68.861-369.328 c-2.095-11.235-13.532-20.096-25.553-19.788l-376.681,9.663C1846.431,2053.045,1838.48,2062.165,1840.079,2073.117z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072242020534073717060000014725970543830466990_",
    gradientUnits: "userSpaceOnUse",
    x1: -688.7869,
    y1: 2583.5051,
    x2: -696.2233,
    y2: 2092.7302,
    gradientTransform: "matrix(-1 0 0 1 1583.2321 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072242020534073717060000014725970543830466990_)"
    },
    d: "M2225.092,2049.852l72.557,395.805 c0.904,4.93,6.712,8.959,11.813,8.959c12.555,0,21.845-9.884,19.581-22.023l-68.912-369.606 c-2.106-11.296-13.552-20.207-25.573-19.898l-6.611,0.17C2225.842,2044.779,2224.606,2047.202,2225.092,2049.852z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1904.1,2308.453c1.46-0.053,2.427-1.327,2.16-2.844l-37.553-213.092 c-1.704-9.67,5.945-15.883,14.331-16.311l39.924-2.036c1.436-0.073,2.384-1.314,2.119-2.772 c-0.265-1.457-1.644-2.578-3.079-2.505l-39.901,2.049c-12.456,0.64-20.603,10.22-18.562,21.833l37.434,213.025 C1901.24,2307.318,1902.64,2308.506,1904.1,2308.453z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2195.738,2422.448l55.306-0.111c11.336-0.023,18.066-10.14,15.643-23.505l-14.894-82.179 c-0.283-1.561-1.751-2.816-3.278-2.802s-2.537,1.29-2.255,2.85l14.845,82.151c1.822,10.081-2.95,17.709-11.095,17.729 l-55.273,0.131c-1.53,0.003-2.547,1.29-2.271,2.874C2192.743,2421.169,2194.207,2422.451,2195.738,2422.448z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007428998578418629900000010657239555793500075_",
    gradientUnits: "userSpaceOnUse",
    x1: -386.1332,
    y1: 2500.054,
    x2: -749.2353,
    y2: 2504.1399,
    gradientTransform: "matrix(-1 0 0 1 1583.2321 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007428998578418629900000010657239555793500075_)"
    },
    d: "M1948.365,2511.196v4.746 l97.815-2.092h138.287c3.333,0,6.035-1.453,6.035-4.787l0,0c0-12.975-9.135-22.892-22.138-22.892h-195.209 c-1.673,0-5.002,0.634-6.484,0.964C1956.412,2489.493,1948.365,2499.894,1948.365,2511.196z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126289316511027214870000013063668482882008201_",
    gradientUnits: "userSpaceOnUse",
    x1: 2076.4106,
    y1: 2423.2373,
    x2: 1944.4755,
    y2: 2798.7449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126289316511027214870000013063668482882008201_)"
    },
    d: "M1925.094,2510.839 c0.027-12.975,10.589-23.4,23.592-23.345l19.724,0.083l77.88,0.357l97.605,0.576c12.975,0.055,23.455,9.419,23.427,22.395 c-0.015,2.565-2.098,2.945-4.664,2.945H1929.75c-1.24,0-2.43,1.197-3.305,0.318c-0.875-0.879-1.364-1.225-1.359-2.465 L1925.094,2510.839z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046305329015664824270000000350786941395994769_",
    gradientUnits: "userSpaceOnUse",
    x1: -619.7878,
    y1: 2537.178,
    x2: -434.5459,
    y2: 2304.0129,
    gradientTransform: "matrix(-1 0 0 1 1583.2321 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046305329015664824270000000350786941395994769_)"
    },
    d: "M2111.291,2225.197 c8.901,0,15.01,8.466,15.01,17.367v243.606h-126.532v-260.973H2111.291z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147179109594798866120000011382223535771132319_",
    gradientUnits: "userSpaceOnUse",
    x1: 2055.6609,
    y1: 2315.5383,
    x2: 1883.1309,
    y2: 3110.5315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147179109594798866120000011382223535771132319_)"
    },
    d: "M2000.876,2225.197h91.212 c8.901,0,14.442,8.466,14.442,17.367v243.606h-122.578v-243.606C1983.952,2233.664,1991.974,2225.197,2000.876,2225.197z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046333083782028755580000008789292537548561545_",
    gradientUnits: "userSpaceOnUse",
    x1: 2491.4312,
    y1: 2337.5681,
    x2: 2492.5586,
    y2: 2554.0771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CB236D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C246D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046333083782028755580000008789292537548561545_)"
    },
    d: "M2545.059,2509.896h-105.783 c0,0,24.019-51.614,67.967-49.059C2551.192,2463.392,2545.059,2509.896,2545.059,2509.896z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.60fec5f75a2d06a2999b708f1a2074a9.svg";
export { ForwardRef as ReactComponent };